/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CorporateProgram } from './';
import {
    CorporateProgramFromJSON,
    CorporateProgramFromJSONTyped,
    CorporateProgramToJSON,
} from './';
import type { CurrencyCode } from './';
import {
    CurrencyCodeFromJSON,
    CurrencyCodeFromJSONTyped,
    CurrencyCodeToJSON,
} from './';
import type { FreelancerVertical } from './';
import {
    FreelancerVerticalFromJSON,
    FreelancerVerticalFromJSONTyped,
    FreelancerVerticalToJSON,
} from './';
import type { RepatriationMetadata } from './';
import {
    RepatriationMetadataFromJSON,
    RepatriationMetadataFromJSONTyped,
    RepatriationMetadataToJSON,
} from './';

/**
 * 
 * @export
 * @interface SignupContext
 */
export interface SignupContext {
    /**
     * 
     * @type {FreelancerVertical}
     * @memberof SignupContext
     */
    freelancerVertical: FreelancerVertical;
    /**
     * 
     * @type {RepatriationMetadata}
     * @memberof SignupContext
     */
    repatriationMetadata?: RepatriationMetadata;
    /**
     * 
     * @type {CorporateProgram}
     * @memberof SignupContext
     */
    corporateProgram?: CorporateProgram;
    /**
     * 
     * @type {CurrencyCode}
     * @memberof SignupContext
     */
    currencyCode: CurrencyCode;
    /**
     * 
     * @type {number}
     * @memberof SignupContext
     */
    minPriceForCountry?: number;
}

/**
 * Check if a given object implements the SignupContext interface.
 */
export function instanceOfSignupContext(value: object): value is SignupContext {
    if (!('freelancerVertical' in value) || value['freelancerVertical'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function SignupContextFromJSON(json: any): SignupContext {
    return SignupContextFromJSONTyped(json, false);
}

export function SignupContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupContext {
    if (json == null) {
        return json;
    }
    return {
        
        'freelancerVertical': FreelancerVerticalFromJSON(json['freelancerVertical']),
        'repatriationMetadata': json['repatriationMetadata'] == null ? undefined : RepatriationMetadataFromJSON(json['repatriationMetadata']),
        'corporateProgram': json['corporateProgram'] == null ? undefined : CorporateProgramFromJSON(json['corporateProgram']),
        'currencyCode': CurrencyCodeFromJSON(json['currencyCode']),
        'minPriceForCountry': json['minPriceForCountry'] == null ? undefined : json['minPriceForCountry'],
    };
}

export function SignupContextToJSON(value?: SignupContext | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'freelancerVertical': FreelancerVerticalToJSON(value['freelancerVertical']),
        'repatriationMetadata': RepatriationMetadataToJSON(value['repatriationMetadata']),
        'corporateProgram': CorporateProgramToJSON(value['corporateProgram']),
        'currencyCode': CurrencyCodeToJSON(value['currencyCode']),
        'minPriceForCountry': value['minPriceForCountry'],
    };
}

